import {createRouter, createWebHistory} from '@ionic/vue-router';
import {RouteRecordRaw} from 'vue-router';
import TabsPage from '../views/TabsPage.vue'
import {updateSeo} from '@/utils/seo';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: TabsPage,
        redirect: '/home',
        children: [
            {
                path: 'home',
                name: 'HomePage',
                component: () => import('@/views/TabStore.vue'),
                meta: {
                    seo: {
                        title: 'ซื้อสลากดิจิทัล | สลากมหาเฮง',
                        description: 'ซื้อสลากดิจิทัลออนไลน์กับสลากมหาเฮง ค้นหาเลขเด็ด เลือกเลขที่ต้องการ และจองสลากได้สะดวก',
                        path: '/home',
                    }
                }
            },
            {
                path: 'myLottery',
                name: 'MyLotteryPage',
                component: () => import('@/views/TabMyLottery.vue'),
                meta: {
                    seo: {
                        title: 'สลากของฉัน | สลากมหาเฮง',
                        description: 'ดูรายการสลากดิจิทัลของฉัน ตรวจสถานะ และติดตามสลากที่ซื้อไว้',
                        path: '/myLottery',
                        robots: 'noindex,nofollow',
                    }
                }
            },
            {
                path: 'profile',
                component: () => import('@/views/TabProfile.vue'),
                meta: {
                    seo: {
                        title: 'โปรไฟล์ | สลากมหาเฮง',
                        description: 'จัดการข้อมูลบัญชี ตั้งค่าภาษา และข้อมูลส่วนตัวในสลากมหาเฮง',
                        path: '/profile',
                        robots: 'noindex,nofollow',
                    }
                }
            },
            {
                path: 'reward',
                component: () => import('@/views/reward/index.vue'),
                meta: {
                    seo: {
                        title: 'ตรวจผลรางวัล | สลากมหาเฮง',
                        description: 'ตรวจผลรางวัลสลาก ตรวจเลขรางวัล และดูข้อมูลการขึ้นเงินรางวัลกับสลากมหาเฮง',
                        path: '/reward',
                    }
                }
            },
            {
                path: 'event',
                component: () => import('@/views/TabEvent.vue'),
                meta: {
                    seo: {
                        title: 'กิจกรรม | สลากมหาเฮง',
                        description: 'ติดตามกิจกรรม โปรโมชัน และสิทธิพิเศษจากสลากมหาเฮง',
                        path: '/event',
                    }
                }
            },
        ]
    },
    {
        path: '/lottery/search',
        component: () => import('@/views/store/Search.vue'),
        meta: {
            seo: {
                title: 'ค้นหาสลาก | สลากมหาเฮง',
                description: 'ค้นหาเลขสลากดิจิทัลที่ต้องการจากสลากมหาเฮง',
                path: '/lottery/search',
                robots: 'noindex,follow',
            }
        }
    },
    {
        path: '/payment',
        component: () => import('@/views/payment/Index.vue'),
        meta: {
            seo: {
                title: 'ชำระเงิน | สลากมหาเฮง',
                description: 'หน้าชำระเงินสำหรับคำสั่งซื้อสลากดิจิทัลในสลากมหาเฮง',
                path: '/payment',
                robots: 'noindex,nofollow',
            }
        }
    },
    {
        path: '/auth/login',
        component: () => import('@/views/auth/Login.vue'),
        meta: {
            seo: {
                title: 'เข้าสู่ระบบ | สลากมหาเฮง',
                description: 'เข้าสู่ระบบสลากมหาเฮงเพื่อซื้อสลากดิจิทัลและจัดการบัญชีของคุณ',
                path: '/auth/login',
                robots: 'noindex,nofollow',
            }
        }
    },
    {
        path: '/auth/callback',
        component: () => import('@/views/auth/CallBack.vue'),
        meta: {
            seo: {
                title: 'กำลังเข้าสู่ระบบ | สลากมหาเฮง',
                description: 'หน้าดำเนินการเข้าสู่ระบบสลากมหาเฮง',
                path: '/auth/callback',
                robots: 'noindex,nofollow',
            }
        }
    },
    {
        path: '/redirect/:af',
        component: () => import('@/views/redirect/af.vue'),
        meta: {
            seo: {
                title: 'เปลี่ยนเส้นทาง | สลากมหาเฮง',
                description: 'หน้าสำหรับเปลี่ยนเส้นทางไปยังสลากมหาเฮง',
                robots: 'noindex,nofollow',
            }
        }
    },
]

const router = createRouter({
    history: createWebHistory('/'),
    routes
})

router.afterEach((to) => {
    updateSeo(to);
});

export default router
